<template>
  <Card>
    <Row>
      <Col :span="{span:24,offset:2}" :md="{span:16,offset:3}" :xl="{span:12,offset:6}">
        <Form :model="formItem" ref="formItem" :label-width="100" :rules="ruleValidate">
          <FormItem label="当前密码" prop="original_password">
            <Input type="password" v-model="formItem.original_password" placeholder="请输入当前密码"></Input>
          </FormItem>
          <FormItem label="新密码" prop="password">
            <Input type="password" v-model="formItem.password" placeholder="新密码长度不能小于8位"></Input>
          </FormItem>
          <FormItem label="确认新密码" prop="password2">
            <Input type="password" v-model="formItem.password2" placeholder="新密码长度不能小于8位"></Input>
          </FormItem>
          <FormItem>
            <Button type="primary" @click="changePasswordSubmit('formItem')">提交</Button>
          </FormItem>
        </Form>
      </Col>
    </Row>
  </Card>
</template>

<script>
import {changePassword} from '@/api/settings'
export default {
  name: 'change-password',
  data () {
    return {
      formItem: {
        original_password: '',
        password: '',
        password2: ''
      },
      ruleValidate: {
        original_password: [
          { required: true, message: '当前密码不能为空', trigger: 'blur' }
        ],
        password: [
          { required: true, message: '新密码不能为空', trigger: 'blur' },
          { type: 'string', min: 8, message: '密码长度不能小于8位', trigger: 'blur' }
        ],
        password2: [
          { required: true, message: '确认新密码不能为空', trigger: 'blur' },
          { type: 'string', min: 8, message: '密码长度不能小于8位', trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    changePasswordSubmit (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          if (this.formItem.password !== this.formItem.password2) {
            this.$Notice.error({
              title: '两次输入的新密码不同！'
            })
          } else {
            changePassword(this.formItem).then(res => {
              let result = res.data
              if (result.code === 200) {
                this.$Notice.success({
                  title: '操作成功！'
                })
                this.formItem = {
                  original_password: '',
                  password: '',
                  password2: ''
                }
              } else {
                this.$Notice.error({
                  title: '操作失败！请求状态码：' + result.code,
                  desc: result.msg
                })
              }
            }).catch(res => {
              this.$Notice.error({
                title: '操作失败！ 请求状态码:' + res.request.status,
                desc: res.request.responseText
              })
            })
          }
        } else {
          this.$Notice.error({title: '请检查输入框！'})
        }
      })
    }
  }
}
</script>

<style scoped>

</style>
